import { render, staticRenderFns } from "./AsignarNombreEquipo.vue?vue&type=template&id=460a8de8&scoped=true"
import script from "./AsignarNombreEquipo.vue?vue&type=script&lang=ts"
export * from "./AsignarNombreEquipo.vue?vue&type=script&lang=ts"
import style0 from "./AsignarNombreEquipo.vue?vue&type=style&index=0&id=460a8de8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460a8de8",
  null
  
)

export default component.exports